import MarkdownRenderer from "../../common/MarkdownRenderer/MarkdownRenderer";
import "./Tooltip.scss";

type TooltipProps = {
	content: string;
};

const Tooltip = ({ content }: TooltipProps) => {
	return (
		<div className="tooltip column">
			<section className="tooltip__body">
				<MarkdownRenderer>{content}</MarkdownRenderer>
			</section>
		</div>
	);
};

export default Tooltip;
